import * as React from 'react';

import { cn } from '@/lib/utils';

const MessageScroller = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (
    {
      className,
      role = 'log',
      'aria-live': ariaLive = 'polite',
      'aria-relevant': ariaRelevant = 'additions text',
      ...props
    },
    ref,
  ) => (
    <div
      ref={ref}
      role={role}
      aria-live={ariaLive}
      aria-relevant={ariaRelevant}
      data-slot="message-scroller"
      className={cn('h-full space-y-2 overflow-y-auto pr-1', className)}
      {...props}
    />
  ),
);
MessageScroller.displayName = 'MessageScroller';

export { MessageScroller };
